import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { CrudService, MessageService, Search, Page } from 'elbuild-ui-lib-core';
import { ProjectEmployee, company, Project } from 'toolbandi-ui-lib';
import { TranslateService } from '@ngx-translate/core';
import * as screenfull from 'screenfull';
import { Screenfull } from 'screenfull';
import { catchError, map } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';


const MONTHS = 24;
const MAX_VALUE = 100000;
@Component({
	selector: 'app-hours-resources',
	templateUrl: './hours-resources.component.html',
	styleUrls: ['./hours-resources.component.scss']
})
export class HoursResourcesComponent implements OnInit {

	@Input()
	projectid: number;
	project: Project;

	@Input()
	companyid: number;

	loading: boolean = true;
	resources: ProjectEmployee[];
	@ViewChild('tablearea', { static: true }) tablearea: ElementRef;
	@ViewChild('inputfield', {}) inputfield: ElementRef;

	@Output()
	goto = new EventEmitter();



	tablefull: boolean;


	months: number[] = Array(MONTHS).fill(1);

	selectedResource: ProjectEmployee;
	selectedMonth: number;
	inputValue: number;

	hoverr: number = undefined;
	hoverc: number = undefined;
	oldvalue: any;
	saving: boolean;

	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		if (event && event.key === 'Enter') {
			this.activateInput();
		}
	}

	constructor(private employeeService: CrudService<ProjectEmployee>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private projectCrudService: CrudService<Project>) { }

	ngOnInit() {
		this.load();

		if (this.projectid) {
			this.load();
			this.projectCrudService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}
	}


	load(): void {
		this.loading = true;
		this.resources = [];

		const advancedSearch = new Search('projectemployee join employee on projectemployee.employeeid = employee.id');



		if (this.projectid) {
			advancedSearch.addSimpleFilter('projectemployee.projectid', this.projectid);
		}

		if (this.companyid) {
			advancedSearch.addSimpleFilter('employee.companyid', this.companyid);
		}

		const datarequest = this.employeeService.searchEntities(ProjectEmployee, 'projectemployee', advancedSearch, new Page(100));
		const countrequest = this.employeeService.countEntities(ProjectEmployee, 'projectemployee', advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {

			this.resources = results[0];

			if (this.resources.length !== results[1].ct) {
				console.error('not showing all rows!');
			}

			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	activateInput(employee?: ProjectEmployee, month?: number) {

		if (!(this.project.isDraft) || this.saving) {
			return;
		}
		if (this.selectedResource !== employee || this.selectedMonth !== month) {


			this.saveUpdate().subscribe(data => {
				if (data) {

					this.selectedResource = employee;
					this.selectedMonth = month;

					if (employee) {
						this.setFocus();
					}
				}
			});

			this.oldvalue = this.getSelectedValue();
		}

	}

	tab(employee: ProjectEmployee, month: number, row: number) {
		this.saveUpdate().subscribe(data => {
			if (data) {
				if (month + 1 < MONTHS) {
					this.selectedMonth = month + 1;
					this.selectedResource = this.resources[row];
				} else {
					if (row + 1 < this.resources.length) {
						this.selectedResource = this.resources[row + 1];
						this.selectedMonth = 0;
					} else {
						this.selectedResource = undefined;
						this.selectedMonth = undefined;
					}
				}

				this.oldvalue = this.getSelectedValue();
				this.setFocus();


			}
		});

	}


	setFocus() {
		if (this.inputfield) {

			setTimeout(() => { // this will make the execution after the above boolean has changed
				if (this.inputfield) {
					this.inputfield.nativeElement.focus();
					this.inputfield.nativeElement.select();
				}
			}, 0);
		}
	}
	saveUpdate(): Observable<boolean> {
		if (this.selectedResource && this.selectedMonth) {

			return this.saveRow();
		} else {
			return of(true);
		}
	}

	select(employee: ProjectEmployee) {
		if (!(this.project.isDraft)) {
			return;
		}
		this.selectedResource = employee;
		this.selectedMonth = undefined;


		this.setFocus();
	}


	dosave() {
		this.saveRow().subscribe(data => {

		}, error => {
			console.log(error);
		});
	}

	private saveRow(): Observable<boolean> {
		if (this.selectedResource && this.checkValue() && !this.saving) {

			if (this.getSelectedValue() !== this.oldvalue) {
				this.saving = true;

				/*
							return this.employeeService.saveEntity(ProjectEmployee, 'projectemployee', this.selectedResource).subscribe(data => {
								this.selectedResource.tot = data.tot;
								this.selectedResource = undefined;
							}, ({ error }) => {
								this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));

							});*/


				return this.employeeService.saveEntity(ProjectEmployee, 'projectemployee', this.selectedResource)
					.pipe(map(data => {
						this.selectedResource.tot = data.tot;
						this.selectedResource = undefined;
						this.saving = false;
						return true;
					}), catchError((err, caught) => {
						console.log(err);
						this.messageService.sendError(err, this.translateService.instant('labels.error-occurred'));
						this.saving = false;
						return of(false);
					}));
			}
			else {
				this.selectedResource = undefined;
				this.selectedMonth = undefined;
				return of(true);
			}
		} else {
			return of(false);
		}
	}




	getSelectedValue(): any {
		let value: any;
		if (this.selectedResource && this.selectedMonth !== undefined) {
			value = this.selectedResource['m' + this.selectedMonth];

		}

		if (this.selectedResource && this.selectedMonth === undefined) {
			value = this.selectedResource.actualcost;
		}
		return value;
	}

	resetSelectedValue() {
		if (this.selectedResource && this.selectedMonth !== undefined) {
			this.selectedResource['m' + this.selectedMonth] = this.oldvalue;;

		}

		if (this.selectedResource && this.selectedMonth === undefined) {
			this.selectedResource.actualcost = this.oldvalue;
		}
	}

	checkValue(): boolean {


		let valid = true;

		const value = this.getSelectedValue();

		const numbvalue = parseInt(value);
		valid = !isNaN(numbvalue) && numbvalue <= MAX_VALUE && numbvalue >= 0;


		if (!valid) {
			this.messageService.sendError('Il valore ' + value + ' non è valido.', this.translateService.instant('labels.error-occurred'));
			this.resetSelectedValue();
		}
		return valid;
	}
	toggleFullscreen() {
		const s = screenfull as Screenfull;
		if (this.tablefull) {

			if (s.isFullscreen) {
				s.exit();
				this.tablefull = false;
			}
		} else {
			if (s.enabled && this.tablearea && this.tablearea.nativeElement) {
				s.toggle(this.tablearea.nativeElement);
				this.tablefull = true;
			}
		}

	}

	gotoResources() {
		this.goto.emit('companyresources');
	}


}
